module.exports = __webpack_public_path__ + "static/media/sopt24ru.c847d6c1.pdf";